import { makeStyles } from "@material-ui/core";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import { TheCycleverseTheme } from "src/theme";
import { CalculatorBodyText, H3Headline } from "../CalculatorTypography";
const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  link: {
    textDecoration: "underline",
    color: theme.openButtonColor,
    cursor: "pointer",
  },

  boldText: {
    fontWeight: 900,
  },

  centerText: {
    textAlign: "center",
  },
}));

export const SecondPartOfTheResult = ({ L }) => {
  const { t } = useTranslation("lebenserwartungsrechner");
  return (
    <CalculatorBodyText>
      <div style={{ textAlign: "center", marginBottom: "-20px" }}>
        <H3Headline>{t("result1Line4")}</H3Headline>
      </div>

      <br />
      <span
        style={{ fontSize: "40px", fontWeight: 900, color: "#12A537", marginTop: "-50px", textAlign: "center" }}
      >{`${Math.round(L)} ${t("years")}`}</span>
    </CalculatorBodyText>
  );
};

const Result1 = ({ field2, L, A }) => {
  const classes = useStyles();
  const { t } = useTranslation("lebenserwartungsrechner");
  return (
    <div className={classes.centerText}>
      <div style={{ fontSize: "medium", fontWeight: 900 }}>{t("resultTitle")}</div>
      {field2 === "weiblich" ? (
        <div style={{ fontSize: "24px", color: "#767676" }}>
          <span>
            {t("result1Line1")}
            <br /> <span>{t("result1Line2a")}</span>{" "}
          </span>
          <span className={classes.boldText}>
            {A} {t("years")}
          </span>
        </div>
      ) : (
        <div style={{ fontSize: "24px", color: "#767676" }}>
          <span>
            {t("result1Line1")}
            <br /> <span>{t("result1Line2b")}</span>{" "}
          </span>
          <span className={classes.boldText}>
            {A} {t("years")}
          </span>
        </div>
      )}
      <SecondPartOfTheResult L={L} />
    </div>
  );
};

export default Result1;
